<template>
  <b-row class="m-0">
    <b-col class="card p-0 topcard">
      <b-row class="m-0 card-body" align-v="center">
        <b-col class="p-0">
          <h3 class="m-0 p-0">Transaction Summary</h3>
        </b-col>
        <b-col class="p-0 text-right" md="auto" style="height: 36px">
          <b-row class="m-0" v-if="showChart">
            <b-col class="p-0">
              <b-select
                :options="chartOptions"
                v-model="chartOption"
                @change="bindChart"
                size="sm"
              ></b-select>
            </b-col>
            <template v-if="chartOption == 'DAY'">
              <b-col class="p-0 pl-2">
                <b-datepicker
                  value-as-date
                  v-model="dayDate"
                  @context="bindChart"
                  size="sm"
                ></b-datepicker>
              </b-col>
            </template>
            <template v-if="chartOption == 'YEAR'">
              <b-col class="p-0 pl-2">
                <b-select
                  :options="years"
                  v-model="yearYear"
                  @change="bindChart"
                  size="sm"
                ></b-select>
              </b-col>
            </template>

            <template v-if="chartOption == 'MONTH'">
              <b-col class="p-0 pl-2" style="width: 200px">
                <b-select
                  :options="months"
                  v-model="month"
                  @change="bindChart"
                  size="sm"
                ></b-select>
              </b-col>
              <b-col class="p-0 pl-2">
                <b-select
                  :options="years"
                  v-model="year"
                  @change="bindChart"
                  size="sm"
                ></b-select>
              </b-col>
            </template>
          </b-row>
        </b-col>
        <b-col md="auto" class="pr-0">
          <a
            v-if="!showChart"
            href="#"
            @click.prevent="
              () => {
                showChart = true;
                bindChart();
                $cookies.set('showChart', 'true', 'y3');
              }
            "
          >
            <i
              class="fa-solid fa-square-plus"
              v-b-tooltip.hover
              title="Expand
              Panel"
            ></i>
          </a>
          <a
            v-if="showChart"
            href="#"
            @click.prevent="
              () => {
                showChart = false;
                $cookies.set('showChart', 'false', 'y3');
              }
            "
          >
            <i
              class="fa-solid fa-square-minus"
              v-b-tooltip.hover
              title="Collapse Panel"
              @click="showChart = true"
            ></i>
          </a>
        </b-col>
      </b-row>
      <div v-if="showChart">
        <b-row class="m-0 card-body pt-0 body-gray">
          <b-col cols="7" class="p-0 pr-4">
            <b-row class="m-0 card shadow-none align-self-stretch h-100">
              <b-col class="p-0 h-100">
                <b-row class="m-0 p-0">
                  <b-col class="p-0">
                    <stats
                      title="Approved"
                      :emitClick="false"
                      class="data-panel data-approved"
                      icon="icomoon icon-status-approved"
                      iconColor="#2BCE89"
                      :selected="graphSelections.approvedAmount"
                      @clicked="
                        graphSelections.approvedAmount = !graphSelections.approvedAmount
                      "
                      :subTitle="(dashboard.approvedAmount / 100) | currency"
                    >
                      <template #footer
                        >{{ dashboard.approvedCount }} Transactions
                      </template>
                    </stats>
                  </b-col>
                  <b-col class="p-0 panel-divider">
                    <stats
                      title="Voids & Refunds"
                      :emitClick="true"
                      class="data-panel data-refunded"
                      icon="icomoon icon-status-refunded"
                      iconColor="#FA6340"
                      :selected="graphSelections.voidRefundAmount"
                      @clicked="
                        graphSelections.voidRefundAmount = !graphSelections.voidRefundAmount
                      "
                      :subTitle="(dashboard.voidRefundAmount / 100) | currency"
                    >
                      <template #footer
                        >{{ dashboard.voidRefundCount }} Transactions
                      </template>
                    </stats>
                  </b-col>
                  <b-col class="p-0 panel-divider">
                    <stats
                      title="Declines"
                      :emitClick="true"
                      icon="icomoon icon-status-declined"
                      iconColor="#F5365B"
                      class="data-panel data-declined"
                      :selected="graphSelections.declinedAmount"
                      @clicked="
                        graphSelections.declinedAmount = !graphSelections.declinedAmount
                      "
                      :subTitle="(dashboard.declinedAmount / 100) | currency"
                    >
                      <template #footer
                        >{{ dashboard.declinedCount }} Transactions
                      </template>
                    </stats>
                  </b-col>
                </b-row>
                <b-row class="m-0 top-divider">
                  <b-col class="card-body">
                    <transaction-chart
                      :graphSelections="graphSelections"
                      :chartData="{
                        approved: dashboard.approved,
                        paymentPlan: dashboard.paymentPlan,
                        paymentPage: dashboard.paymentPage,
                        virtual: dashboard.virtual,
                        paymentRequest: dashboard.paymentRequest,
                        terminal: dashboard.terminal,
                        membership: dashboard.membership,
                        decline: dashboard.decline,
                        voidRefund: dashboard.voidRefund,
                      }"
                    ></transaction-chart>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="5" class="p-0 h-100">
            <b-row class="m-0 card shadow-none h-100">
              <b-col class="p-0 d-flex flex-column">
                <b-row class="m-0 flex-grow-1">
                  <b-col class="card-body" align-self="center">
                    <transaction-module-chart
                      :chartData="moduleData"
                    ></transaction-module-chart>
                  </b-col>
                </b-row>
                <b-row class="m-0">
                  <b-col class="p-0">
                    <b-row class="m-0 top-divider">
                      <b-col
                        class="p-0"
                        v-if="isAdmin || hasRole('PROCESSTERMINALPAYMENTS')"
                      >
                        <stats
                          title="Terminal"
                          class="data-panel data-terminal"
                          :emitClick="true"
                          icon="fa-solid fa-circle-dot"
                          iconColor="#1395ba"
                          :selected="graphSelections.terminalAmount"
                          @clicked="
                            graphSelections.terminalAmount = !graphSelections.terminalAmount
                          "
                          :subTitle="
                            (dashboard.terminalAmount / 100) | currency
                          "
                        >
                          <template #footer
                            >{{ dashboard.terminalCount }} Transactions
                          </template>
                        </stats>
                      </b-col>
                      <b-col
                        class="p-0 panel-divider"
                        v-if="isAdmin || hasRole('PROCESSVIRTUALPAYMENTS')"
                      >
                        <stats
                          title="Virtual"
                          :emitClick="true"
                          class="data-panel data-virtual"
                          icon="fa-solid fa-circle-dot"
                          iconColor="#0f5b78"
                          :selected="graphSelections.virtualAmount"
                          @clicked="
                            graphSelections.virtualAmount = !graphSelections.virtualAmount
                          "
                          :subTitle="(dashboard.virtualAmount / 100) | currency"
                        >
                          <template #footer
                            >{{ dashboard.virtualCount }} Transactions
                          </template>
                        </stats>
                      </b-col>
                      <b-col
                        class="p-0 panel-divider"
                        v-if="isAdmin || hasRole('VIEWPAYMENTPLANS')"
                      >
                        <stats
                          title="Payment Plans"
                          :emitClick="true"
                          icon="fa-solid fa-circle-dot"
                          iconColor="#d94e1f"
                          class="data-panel data-plans"
                          :selected="graphSelections.paymentPlanAmount"
                          @clicked="
                            graphSelections.paymentPlanAmount = !graphSelections.paymentPlanAmount
                          "
                          :subTitle="
                            (dashboard.paymentPlanAmount / 100) | currency
                          "
                        >
                          <template #footer
                            >{{ dashboard.paymentPlanCount }} Transactions
                          </template>
                        </stats>
                      </b-col>
                    </b-row>
                    <b-row class="m-0 top-divider">
                      <b-col
                        class="p-0"
                        v-if="isAdmin || hasRole('VIEWMEMBERSHIPS')"
                      >
                        <stats
                          title="Memberships"
                          :emitClick="true"
                          icon="fa-solid fa-circle-dot"
                          iconColor="#ef8b2c"
                          class="data-panel data-memberships"
                          :selected="graphSelections.membershipAmount"
                          @clicked="
                            graphSelections.membershipAmount = !graphSelections.membershipAmount
                          "
                          :subTitle="
                            (dashboard.membershipAmount / 100) | currency
                          "
                        >
                          <template #footer
                            >{{ dashboard.membershipCount }} Transactions
                          </template>
                        </stats>
                      </b-col>
                      <b-col
                        class="p-0 panel-divider"
                        v-if="hasRole('VIEWPAYMENTREQUESTS')"
                      >
                        <stats
                          title="Payment Requests"
                          :emitClick="true"
                          icon="fa-solid fa-circle-dot"
                          iconColor="#ebc844"
                          class="data-panel data-requests"
                          :selected="graphSelections.paymentRequestAmount"
                          @clicked="
                            graphSelections.paymentRequestAmount = !graphSelections.paymentRequestAmount
                          "
                          :subTitle="
                            (dashboard.paymentRequestAmount / 100) | currency
                          "
                        >
                          <template #footer
                            >{{ dashboard.paymentRequestCount }} Transactions
                          </template>
                        </stats>
                      </b-col>
                      <b-col class="p-0 data-page panel-divider">
                        <stats
                          title="Payment Page"
                          :emitClick="true"
                          icon="fa-solid fa-circle-dot"
                          iconColor="#a2b86c"
                          class="data-panel data-page"
                          :selected="graphSelections.paymentPageAmount"
                          @clicked="
                            graphSelections.paymentPageAmount = !graphSelections.paymentPageAmount
                          "
                          :subTitle="
                            (dashboard.paymentPageAmount / 100) | currency
                          "
                        >
                          <template #footer
                            >{{ dashboard.paymentPageCount }} Transactions
                          </template>
                        </stats>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Stats from "@/components/Cards/Stats.vue";
import TransactionChart from "@/views/Components/Dashboard/TransactionChart.vue";
import TransactionModuleChart from "@/views/Components/Dashboard/TransactionModuleChart.vue";
import BaseCheckbox from "../../../components/Inputs/BaseCheckbox.vue";

export default {
  inject: ["hasRole"],
  components: {
    Stats,
    TransactionChart,
    TransactionModuleChart,
    BaseCheckbox,
  },
  props: {
    monthGet: {
      type: String,
      default: "/api/dashboard/getDashboardMonthly",
    },
    dayGet: {
      type: String,
      default: "/api/dashboard/GetDashboardDay",
    },
    yearGet: {
      type: String,
      default: "/api/dashboard/GetDashboardYear",
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    var showChartCookie = $cookies.get("showChart");

    if (showChartCookie) {
      this.showChart = showChartCookie == "true";
    } else {
      this.showChart = true;
    }

    this.month = new Date().getMonth() + 1;
    this.year = new Date().getFullYear();
    this.yearYear = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
      this.years.push(new Date().getFullYear() - i);
    }

    if (this.showChart) this.bindMonthly();
  },

  data() {
    return {
      graphSelections: {
        approvedAmount: true,
        voidRefundAmount: true,
        declinedAmount: true,
        paymentPlanAmount: false,
        virtualAmount: false,
        terminalAmount: false,
        paymentRequestAmount: false,
        membershipAmount: false,
        paymentPageAmount: false,
      },
      showChart: true,
      years: [],
      dayDate: new Date(),
      chartOptions: [
        { value: "DAY", text: "Day" },
        { value: "MONTH", text: "Month" },
        { value: "YEAR", text: "Year" },
      ],
      chartOption: "MONTH",
      months: [],
      theMonths: [
        { value: "1", text: "January" },
        { value: "2", text: "February" },
        { value: "3", text: "March" },
        { value: "4", text: "April" },
        { value: "5", text: "May" },
        { value: "6", text: "June" },
        { value: "7", text: "July" },
        { value: "8", text: "August" },
        { value: "9", text: "September" },
        { value: "10", text: "October" },
        { value: "11", text: "November" },
        { value: "12", text: "December" },
      ],
      moduleData: [],
      month: null,
      year: null,
      yearYear: null,
      dashboard: null,
    };
  },
  methods: {
    bindChart() {
      if (this.chartOption == "DAY") this.bindDay();
      else if (this.chartOption == "MONTH") {
        this.bindMonthly();
      } else if (this.chartOption == "YEAR") {
        this.bindYearly();
      }
    },
    setChartData(data) {
      this.dashboard = data;

      this.moduleData = [];

      this.moduleData.push(data.terminalAmount / 100);
      this.moduleData.push(data.virtualAmount / 100);
      this.moduleData.push(data.paymentPlanAmount / 100);
      this.moduleData.push(data.membershipAmount / 100);
      this.moduleData.push(data.paymentRequestAmount / 100);
      this.moduleData.push(data.paymentPageAmount / 100);
    },
    async bindYearly() {
      var r = await this.$client.get(`${this.yearGet}?year=${this.yearYear}`);
      this.setChartData(r.data.value);
    },
    async bindDay() {
      let dt = this.dayDate;

      var r = await this.$client.get(
        `${this.dayGet}?day=${dt.getDate()}&month=${parseInt(dt.getMonth()) +
          1}&year=${dt.getFullYear()}`
      );

      this.setChartData(r.data.value);
    },
    async bindMonthly() {
      var month = new Date().getMonth() + 1;

      //Only show months that have passed
      this.months = [];

      if (this.year == new Date().getFullYear()) {
        for (var i = 0; i < month; i++) {
          this.months.push(this.theMonths[i]);
        }
      } else {
        for (var i = 0; i < 12; i++) {
          this.months.push(this.theMonths[i]);
        }
      }

      var r = await this.$client.get(
        this.monthGet + "?month=" + this.month + "&year=" + this.year
      );

      if (r.data.value.hasUserNotification) {
        this.$emitter.emit(
          "show-userNotification",
          r.data.value.hasUserNotification
        );
      } else {
        this.$emitter.emit(
          "hide-userNotification",
          r.data.value.hasUserNotification
        );
      }

      this.setChartData(r.data.value);
    },
  },
};
</script>

<style></style>
